if (!window.WebAssessmentCharts) {
    window.WebAssessmentCharts = {}; // Create namespace if it doesn't exist
}

// Store original data structure
WebAssessmentCharts.originalData = {};

WebAssessmentCharts.createChartFromTable = function(tableId, chartId, charts, isHorizontal = true) {
    //console.log(`Starting chart creation for ${chartId}...`);
    // Get the table element
    const table = document.getElementById(tableId);
    if (!table) {
        console.error('Table not found:', tableId);
        return; // Stop execution if table is not found
    }
    
    //console.log(`Found table for ${chartId}, gathering data...`);
    const rows = table.getElementsByTagName('tr');
    const labels = [];
    const policyData = [];
    
    // Always read current data from the table instead of using stored data
    // This ensures the chart reflects the current state of the table
    for (let i = 1; i < rows.length - 1; i++) { // Skip the last row for total
        const row = rows[i];
        //console.log(`Processing row ${i} in table ${tableId}`);
        // Skip hidden rows
        if (row.style.display === 'none' || window.getComputedStyle(row).display === 'none') {
            //console.log(`Skipping hidden row ${i} in table ${tableId}`);
            continue;
        }
        const cells = row.getElementsByTagName('td');
        if (cells.length < 2) {
            console.warn(`Skipped row ${i} in table ${tableId} due to insufficient cells.`);
            continue;
        }
        labels.push(cells[0].innerText);
        const parsed = parseFloat(cells[1].innerText);
        // Use null for non-numeric values (e.g. "N/A", "Not Applicable") so chart doesn't show a 0 bar
        policyData.push(Number.isNaN(parsed) ? null : parsed);
    }
    
    //console.log(`Data prepared for ${chartId}:`, { labels, policyData });
    
    // Dynamically set canvas height/width based on the number of labels
    const canvas = document.getElementById(chartId);
    if (!canvas) {
        console.error(`Canvas not found for ${chartId}`);
        return;
    }
    //console.log(`Found canvas for ${chartId}, setting dimensions...`);
    
    const labelCount = labels.length;
    const barSize = 50; // Fixed size per label (can be adjusted)
    
    // For horizontal charts (Y-axis is the index axis)
    if (isHorizontal) {
        const minHeight = 200;  // Minimum height for very few labels
        const maxHeight = 1000; // Maximum height if too many labels
        const calculatedHeight = labelCount * 50; // Ensure 50px per bar
        canvas.height = Math.min(maxHeight, Math.max(minHeight, calculatedHeight));
        //console.log(`Set horizontal chart dimensions for ${chartId}`);
    } else {
        // For vertical charts (X-axis is the index axis)
        const minWidth = 400;  // Minimum width for very few labels
        const maxWidth = 1200; // Maximum width if too many labels
        canvas.width = Math.min(maxWidth, Math.max(minWidth, labelCount * barSize));
        canvas.height = 400;
        //console.log(`Set vertical chart dimensions for ${chartId}`);
    }
    
    const ctx = canvas.getContext('2d');
    if (!ctx) {
        console.error('Canvas context not found:', chartId);
        return;
    }
    
    // Check if a chart already exists for this canvas and destroy it if it does
    if (charts[chartId]) {
        //console.log(`Destroying existing chart for ${chartId}`);
        charts[chartId].destroy();
        charts[chartId] = null;
    }
    
    const numericData = policyData.filter(v => v != null && !Number.isNaN(v));
    let maxValue = numericData.length ? Math.max(...numericData) : 0;
    maxValue = Math.ceil(maxValue / 5) * 5;
    //console.log(`Calculated max value for ${chartId}: ${maxValue}`);
    
    // Create a new chart instance and save it in the charts object
    charts[chartId] = new Chart(ctx, {
        type: 'bar',
        data: {
            labels: labels,
            datasets: [
                {
                    label: 'Maturity Rating',
                    data: policyData,
                    backgroundColor: 'rgba(49, 77, 118, 1)',
                    hoverBackgroundColor: 'rgba(49, 77, 118, 1)',
                    borderColor: 'rgb(49, 77, 118)',
                    borderWidth: 1
                }
            ]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            indexAxis: isHorizontal ? 'y' : 'x',
            scales: {
                x: {
                    beginAtZero: true,
                    max: isHorizontal ? maxValue : undefined,
                    ticks: {
                        autoSkip: false,
                        maxRotation: 0,
                        minRotation: 0,
                        padding: 5,
                    },
                    grid: {
                        offset: true,
                    }
                },
                y: {
                    beginAtZero: true,
                    max: isHorizontal ? undefined : 5,
                    ticks: {
                        autoSkip: false,
                        padding: 5,
                    },
                    grid: {
                        offset: true,
                    }
                }
            },
            plugins: {
                legend: {
                    display: false
                }
            }
        }
    });
    //console.log(`Chart creation completed for ${chartId}`);
    // Trigger Bootstrap modal reflow if the modal is open
    // If the modal is open, call handleUpdate to readjust its position in case the height changed (e.g., chart rendered)
    const modalEl = document.getElementById('viewResultsModal');
    if (modalEl && modalEl.classList.contains('show')) {
        // Bootstrap 5: get the modal instance and call handleUpdate
        const modalInstance = bootstrap.Modal.getInstance(modalEl);
        if (modalInstance && typeof modalInstance.handleUpdate === 'function') {
            modalInstance.handleUpdate();
            //console.log('[createChartFromTable] Called handleUpdate on modal due to possible height change');
        }
    }
};